package one.healthium.onboarding.data

import one.healthium.onboarding.domain.configs.TransparencyAccessScreenConfig
import one.healthium.onboarding.domain.screens.ScreensGroupModel

actual class ConditionalScreensFilter {
    actual fun filter(screens: List<ScreensGroupModel>): List<ScreensGroupModel> {
        return screens
            .filter { it.screens.isNotEmpty() }
            .map { screenGroup ->
                screenGroup.copy(screens = screenGroup.screens.filter { screen ->
                    when (screen.config) {
                        is TransparencyAccessScreenConfig -> false
                        else -> true
                    }
                })
            }
    }
}